module.exports = __webpack_public_path__ + "static/img/643fc10e603249bb2eea2ce0a94dbbf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ck_white.png
// module id = UZcy
// module chunks = 1